import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean
} from 'vue-mc/validation';

export class Restaurant extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            name: '',
            address: '',
            city: '',
            province: '',
            zip_code: '',
            phone: '',
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            working_hours: '',
            delivery_fee: null,
            tax: null,
            currency: '',
            available: true,
            availability_message: ''
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            name: String,
            address: String,
            city: String,
            province: String,
            zip_code: String,
            phone: String,
            first_name: String,
            last_name: String,
            email: String,
            password: String,
            working_hours: String,
            delivery_fee: Number,
            tax: Number,
            currency: String,
            available: Boolean,
            availability_message: String
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            name: string.and(required),
            address: string,
            city: string,
            province: string,
            zip_code: string,
            phone: string,
            first_name: string.and(required),
            last_name: string.and(required),
            email: string.and(required),
            password: string,
            working_hours: string,
            delivery_fee: integer.or(equal(null)),
            currency: string,
            available: boolean,
            availability_message: string
        };
    }

    public routes() {
        return {
            fetch: "restaurants/{id}",
            save: "restaurants",
            delete: "restaurants/{id}"
        };
    }
}

export class RestaurantCollection extends Collection {
    public model() {
        return Restaurant;
    }

    public defaults() {
        return {
            orderBy: 'name',
        };
    }

    public routes() {
        return {
            fetch: "restaurants",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
